import { Typography, Box, TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';
import { archivoRobotoFontFamily, interRobotoFontFamily } from '../../../shared/style/fontFamilies';

export const FundsTableContainer = styled(Box)(({ theme }) => ({
  backgroundColor: 'white',
  borderRadius: '8px',
  padding: '24px',
  marginTop: '32px',
  marginBottom: '30px',
  border: '1px solid #e5e5e5',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.08)',
  [theme.breakpoints.down('md')]: {
    padding: '20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
    marginBottom: '20px',
  },
}));

export const FundsTableHeader = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgb(16, 72, 102)',
  padding: '8px 16px',
  borderRadius: '8px 8px 0 0',
  margin: '-24px -24px 24px -24px',
  [theme.breakpoints.down('md')]: {
    padding: '6px 14px',
    margin: '-20px -20px 20px -20px',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '6px 12px',
    margin: '-16px -16px 16px -16px',
  },
}));

export const FundsTableTitle = styled(Typography)(({ theme }) => ({
  fontFamily: archivoRobotoFontFamily,
  fontSize: '20px',
  margin: 0,
  '&&': {
    color: '#ffffff !important',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
}));

export const FiltersContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '16px',
  marginBottom: '20px',
  flexWrap: 'wrap',
  alignItems: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    gap: '12px',
    alignItems: 'stretch',
  },
}));

export const FilterWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
});

export const FilterLabel = styled(Typography)({
  fontFamily: archivoRobotoFontFamily,
  fontSize: '16px',
  fontWeight: 500,
  color: '#191919',
  margin: 0,
});

export const StyledTableHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: '#f5f5f5',
  fontFamily: archivoRobotoFontFamily,
  fontSize: '14px',
  fontWeight: 600,
  textTransform: 'uppercase',
  color: '#191919',
  padding: '12px 16px',
  borderBottom: '1px solid #e0e0e0',
  '&.sortable': {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#eeeeee',
    },
  },
}));

export const StyledTableRow = styled(TableRow)(({ isEven }) => ({
  backgroundColor: isEven ? '#fafafa' : 'white',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
}));

export const StyledTableCell = styled(TableCell)({
  fontFamily: interRobotoFontFamily,
  fontSize: '14px',
  padding: '12px 16px',
  borderBottom: '1px solid #e0e0e0',
  color: '#191919',
  '&.purple-column': {
    color: '#7b569b',
    '& *': {
      color: '#7b569b !important',
    },
  },
});

export const FundTypePill = styled(Box)(({ fundType }) => {
  const colors = {
    'Alumni Fund': { bg: '#DBEAFE', text: '#1D4ED8' },
    'AF': { bg: '#DBEAFE', text: '#1D4ED8' },
    'Focused Fund': { bg: '#F3E8FF', text: '#7E22CE' },
    'FF': { bg: '#F3E8FF', text: '#7E22CE' },
    'Foundation Fund': { bg: '#CFFAFE', text: '#0E7490' },
    'FOUND': { bg: '#CFFAFE', text: '#0E7490' },
  }[fundType] || { bg: '#F3F4F6', text: '#374151' };

  return {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: '16px',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: archivoRobotoFontFamily,
    backgroundColor: colors.bg,
    color: colors.text,
  };
});

export const ClickableLink = styled(Typography)({
  fontFamily: interRobotoFontFamily,
  fontSize: '14px',
  color: '#7b569b',
  fontWeight: 600,
  cursor: 'pointer',
  textDecoration: 'none',
  '&:hover': {
    textDecoration: 'underline',
  },
});

export const PurpleText = styled(Typography)({
  fontFamily: interRobotoFontFamily,
  fontSize: '14px',
  color: '#7b569b !important',
  fontWeight: 600,
});

